






































































































































































































































































import {Component, Watch} from 'vue-property-decorator';
import {SET_LOCATIONS, SET_LOCATIONS2} from '@/store/mutationTypes';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import DebounceMixin from '@/mixins/DebounceMixin';
import {ValidationObserver} from 'vee-validate';
import {Biodata, biodataModule} from '@/store/modules/biodata';
import {swalSuccess, swalError} from '@/plugins/swal';

@Component
export default class FormAddress extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  @biodataModule.State('locations') locations!: Biodata[];
  @biodataModule.Mutation(SET_LOCATIONS) setLocation!: Function;
  @biodataModule.Action('getLocation') getLocation!: Function;

  @biodataModule.State('locations2') locations2!: Biodata[];
  @biodataModule.Mutation(SET_LOCATIONS2) setLocation2!: Function;
  @biodataModule.Action('getLocation2') getLocation2!: Function;

  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };

  disableButton = false;
  menu = false;
  form = {
    address: '',
    id_location: '',
    rt: '',
    rw: '',
    post_code: '',
    address_domisili: '',
    id_location_domisili: '',
    rt_domisili: '',
    rw_domisili: '',
    post_code_domisili: '',
  };
  isSame = false;
  location: any = null;
  searchProduct = '';
  searchProduct2 = '';
  radioGroup = null;
  swalOption = {
    title: 'Profile',
    text: 'Apakah anda ingin mengubah Profile?',
    type: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
  };
  get rules() {
    return {
      address: 'required',
      id_location: 'required',
      rt: '',
      rw: 'required',
      post_code: 'required',
      id_location_domisili: 'required',
      address_domisili: 'required',
      rt_domisili: '',
      rw_domisili: 'required',
      post_code_domisili: 'required',
    };
  }
  async mounted() {
    await this.fetchDetail();
  }
  @Watch('isSame')
  onIssameChanged(val: any) {
    if (val) {
      this.form.rt_domisili = this.form.rt;
      this.form.rw_domisili = this.form.rw;
      this.form.address_domisili = this.form.address;
      this.form.post_code_domisili = this.form.post_code;
      this.form.id_location_domisili = this.form.id_location;
    }
  }

  @Watch('searchProduct')
  onSearchProductChanged(val: string) {
    if (!val) return;

    this.debounce(() => {
      this.searchAll(val);
    }, 1000);
  }

  @Watch('searchProduct2')
  onSearchProduct2Changed(val: string) {
    if (!val) return;

    this.debounce(() => {
      this.searchAll2(val);
    }, 1000);
  }

  async searchAll(value: any) {
    this.startLoading('lookup');
    await this.getLocation({
      search: value,
    });
    this.finishLoading('lookup');
  }

  async searchAll2(value: any) {
    this.startLoading('lookup');
    await this.getLocation2({
      search: value,
    });
    this.finishLoading('lookup');
  }
  destroyed() {
    this.setLocation([]);
  }
  async fetchDetail() {
    try {
      this.startLoading('detail');
      const data = await this.$store.dispatch('biodata/getAddress');
      if (data.data !== null) {
        this.form = data.data;
        if (data.data.locations) {
          this.searchAll(data.data.locations.sub_district);
        }
        if (data.data.locationsDomisili) {
          this.searchAll2(data.data.locationsDomisili.sub_district);
        }
      }
      this.finishLoading('detail');
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }

  async onSubmit() {
    try {
      this.startLoading('saving');
      const res = await this.$store.dispatch(
        'biodata/updateAddress',
        this.form,
      );

      if (res.status === 200) {
        swalSuccess.fire({
          title: 'Success!',
          text: res.data.message,
        });
        this.finishLoading('saving');
      }
      this.disableButton = false;
      this.fetchDetail();
      this.$emit('nextStep', 3);
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
}
